export default __webpack_public_path__ + "static/media/logout.87e27593.svg";